import { render } from "./Payroll.vue?vue&type=template&id=19f27292&scoped=true"
import script from "./Payroll.vue?vue&type=script&lang=js"
export * from "./Payroll.vue?vue&type=script&lang=js"

import "./Payroll.vue?vue&type=style&index=0&id=19f27292&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f27292"]])

export default __exports__